/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

// ---------------------------
// AUTO-GENERATED. DO NOT EAT.
// ---------------------------

import { Geometry, isGeometry } from "@cartographerio/geometry";
import {
  ProjectId,
  isProjectId,
  SurveyId,
  isSurveyId,
  SurveyModuleId,
  isSurveyModuleId,
  TeamId,
  isTeamId,
  Timestamp,
  isTimestamp,
  WorkspaceId,
  isWorkspaceId,
} from "../core/types.generated";
import { UserRef, isUserRef } from "../user/types.generated";

export interface SurveyRef {
  moduleId: SurveyModuleId;
  surveyId: SurveyId;
}

export type SurveyCollaborationModel = "CrossWorkspace" | "SingleWorkspace";

export type SurveyPermissionModel =
  | "RoleBasedSensitive"
  | "RoleBased"
  | "WorkspaceVisible"
  | "WorkspaceDownloadable";

export interface SurveyNames {
  shortName: string;
  longName: string;
}

export interface SurveyModuleSummary {
  moduleId: SurveyModuleId;
  names: SurveyNames;
}

export type SurveyStatus =
  | "draft"
  | "complete"
  | "approved"
  | "review"
  | "rejected";

export interface SurveyFV1<A> {
  id: SurveyId;
  type: SurveyModuleId;
  workspaceId: WorkspaceId;
  created: Timestamp;
  updated: Timestamp;
  surveyor: UserRef;
  status: SurveyStatus;
  data: A;
}

export interface SurveyFV2<A> {
  id: SurveyId;
  moduleId: SurveyModuleId;
  projectId: ProjectId;
  teamId?: TeamId | null;
  created: Timestamp;
  updated: Timestamp;
  surveyor: UserRef;
  status: SurveyStatus;
  data: A;
}

export interface SurveyMetadata {
  geometry?: Geometry | null;
  timestamp?: Timestamp | null;
  workspaceName: string;
  projectName?: string | null;
  teamName?: string | null;
  description?: string | null;
}

export type SurveyV1 = SurveyFV1<unknown>;

export type SurveyV2 = SurveyFV2<unknown>;

export type SurveySummaryV1 = SurveyFV1<SurveyMetadata>;

export type SurveySummaryV2 = SurveyFV2<SurveyMetadata>;

export const isSurveyRef = (v: any): v is SurveyRef => {
  return (
    typeof v === "object" &&
    v != null &&
    "moduleId" in v &&
    isSurveyModuleId(v.moduleId) &&
    "surveyId" in v &&
    isSurveyId(v.surveyId)
  );
};

export const isSurveyCollaborationModel = (
  v: any
): v is SurveyCollaborationModel => {
  return v === "CrossWorkspace" || v === "SingleWorkspace";
};

export const isSurveyPermissionModel = (v: any): v is SurveyPermissionModel => {
  return (
    v === "RoleBasedSensitive" ||
    v === "RoleBased" ||
    v === "WorkspaceVisible" ||
    v === "WorkspaceDownloadable"
  );
};

export const isSurveyNames = (v: any): v is SurveyNames => {
  return (
    typeof v === "object" &&
    v != null &&
    "shortName" in v &&
    typeof v.shortName === "string" &&
    "longName" in v &&
    typeof v.longName === "string"
  );
};

export const isSurveyModuleSummary = (v: any): v is SurveyModuleSummary => {
  return (
    typeof v === "object" &&
    v != null &&
    "moduleId" in v &&
    isSurveyModuleId(v.moduleId) &&
    "names" in v &&
    isSurveyNames(v.names)
  );
};

export const isSurveyStatus = (v: any): v is SurveyStatus => {
  return (
    v === "draft" ||
    v === "complete" ||
    v === "approved" ||
    v === "review" ||
    v === "rejected"
  );
};

export const isSurveyFV1 =
  <A>(isA: (a: any) => a is A) =>
  (v: any): v is SurveyFV1<A> => {
    return (
      typeof v === "object" &&
      v != null &&
      "id" in v &&
      isSurveyId(v.id) &&
      "type" in v &&
      isSurveyModuleId(v.type) &&
      "workspaceId" in v &&
      isWorkspaceId(v.workspaceId) &&
      "created" in v &&
      isTimestamp(v.created) &&
      "updated" in v &&
      isTimestamp(v.updated) &&
      "surveyor" in v &&
      isUserRef(v.surveyor) &&
      "status" in v &&
      isSurveyStatus(v.status) &&
      "data" in v &&
      isA(v.data)
    );
  };

export const isSurveyFV2 =
  <A>(isA: (a: any) => a is A) =>
  (v: any): v is SurveyFV2<A> => {
    return (
      typeof v === "object" &&
      v != null &&
      "id" in v &&
      isSurveyId(v.id) &&
      "moduleId" in v &&
      isSurveyModuleId(v.moduleId) &&
      "projectId" in v &&
      isProjectId(v.projectId) &&
      (!("teamId" in v) || isTeamId(v.teamId) || v.teamId === null) &&
      "created" in v &&
      isTimestamp(v.created) &&
      "updated" in v &&
      isTimestamp(v.updated) &&
      "surveyor" in v &&
      isUserRef(v.surveyor) &&
      "status" in v &&
      isSurveyStatus(v.status) &&
      "data" in v &&
      isA(v.data)
    );
  };

export const isSurveyMetadata = (v: any): v is SurveyMetadata => {
  return (
    typeof v === "object" &&
    v != null &&
    (!("geometry" in v) || isGeometry(v.geometry) || v.geometry === null) &&
    (!("timestamp" in v) || isTimestamp(v.timestamp) || v.timestamp === null) &&
    "workspaceName" in v &&
    typeof v.workspaceName === "string" &&
    (!("projectName" in v) ||
      typeof v.projectName === "string" ||
      v.projectName === null) &&
    (!("teamName" in v) ||
      typeof v.teamName === "string" ||
      v.teamName === null) &&
    (!("description" in v) ||
      typeof v.description === "string" ||
      v.description === null)
  );
};

export const isSurveyV1 = (v: any): v is SurveyV1 => {
  return isSurveyFV1((a0: any): a0 is unknown => true)(v);
};

export const isSurveyV2 = (v: any): v is SurveyV2 => {
  return isSurveyFV2((a0: any): a0 is unknown => true)(v);
};

export const isSurveySummaryV1 = (v: any): v is SurveySummaryV1 => {
  return isSurveyFV1((a0: any): a0 is SurveyMetadata => isSurveyMetadata(a0))(
    v
  );
};

export const isSurveySummaryV2 = (v: any): v is SurveySummaryV2 => {
  return isSurveyFV2((a0: any): a0 is SurveyMetadata => isSurveyMetadata(a0))(
    v
  );
};

/* eslint-enable @typescript-eslint/explicit-module-boundary-types */
/* eslint-enable @typescript-eslint/no-use-before-define */
/* eslint-enable @typescript-eslint/no-unused-vars */
/* eslint-enable @typescript-eslint/no-explicit-any */
/* eslint-enable @typescript-eslint/no-empty-interface */
